export const formatDurationLabel = (durationMs: number, isNL: boolean) => {
  const hourPostFix = isNL ? 'u' : 'h';
  const HOUR_IN_MS = 3600000;
  const MINUTE_IN_MS = 60000;

  const hours = Math.floor(durationMs / HOUR_IN_MS);
  const minutes = Math.floor((durationMs % HOUR_IN_MS) / MINUTE_IN_MS);

  if (hours === 0) {
    return `${minutes}m`;
  }

  return minutes === 0 ? `${hours}${hourPostFix}` : `${hours}h ${minutes}m`;
};
